const mainSelectConstants = {
    SELECT_CONTAINER_CLASS: '.select-container',
    MOUSE_DOWN_EVENT: 'mousedown',
};

export default mainSelectConstants;
